import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { IonToggle } from '@ionic/angular/standalone';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'demooz-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  imports: [IonToggle, ReactiveFormsModule],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class DemoozToggleComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelToggle: string = '';
    @Input({alias : 'formName', required : false}) formName: string|number = '';
    @Input({alias : 'labelPlacement', required : false}) labelPlacement: 'start'|'end' = 'start';
    @Input({alias : 'enableOnOffLabels', required : false}) enableOnOffLabels: boolean = false;
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;
    @Input({alias : 'noMargin', required : false}) noMargin: boolean = false;
     
    constructor(
         public formGroupDirective: FormGroupDirective
    ) { }

    ngOnInit() {}
    
    async ngOnChanges(changes: SimpleChanges) {                
        if(changes['disabled'] && changes['disabled'].currentValue !== null){    
            if(this.disabled === true){
                this.formGroupDirective.form.controls[this.formName].disable({emitEvent: false});
            }
            else{
                this.formGroupDirective.form.controls[this.formName].enable({emitEvent: false});
            }
        }
    }

}
